import { Box } from "@mui/material";
import { Address } from "@/common/apis/dtos";
import { formatNumber } from "@/common/utilities/display-utilities";

const COORD_DIGITS = 5;
const ADDRESS_OR_COORDS_STRING = 'GPS ONLY';

export interface StreetAddressProps {
    address: Address | undefined;
}

export const StreetAddress = (props: StreetAddressProps) => {
    return(
        <>
            {props.address && getAddressOrCoords(props.address)}
        </>
    );
};

const getAddressOrCoords = (address: Address) => address.addressLine1?.trim().toUpperCase() === ADDRESS_OR_COORDS_STRING
    ? getCoords(address.latitude, address.longitude)
    : getAddressLines(address);

const getAddressLines = (address: Address) => {
    const addressLines = [address.addressLine1, address.addressLine2, address.addressLine3, address.addressLine4];
    return addressLines.map((line, index) => {
        return line && (
            <Box key={index} data-testid={`address-line-${index + 1}`}>
                {line}
            </Box>
        );
    });
};

const getCoords = (latitude: number | undefined, longitude: number | undefined) => {
    return(
        <Box data-testid="address-coords">
            {getCoord(latitude)}, {getCoord(longitude)}
        </Box>
    );
};

const getCoord = (coord: number | undefined): string => formatNumber(coord, COORD_DIGITS);
